import { Box, CircularProgress } from '@mui/material';
import { Suspense } from 'react';
import {
  useGetPortfolioAnalysisHeatQuery,
  useGetPortfolioAnalysisPowerQuery,
  useGetPortfolioAnalysisSubscriptionQuery,
  useGetPortfolioAnalysisWaterQuery,
} from '../../../../api/energy-analysis/portfolioAnalysisApiSlice';
import PortfolioAnalysisManagementDrawer from '@/features/service-management/components/portfolio-analysis/PortfolioAnalysisManagementDrawer';

const PortfolioAnalysisDrawerContainer = ({ isOpen, onClose, account }) => {
  const { data: subscriptionData, isFetching: isFetchingSubscription } =
    useGetPortfolioAnalysisSubscriptionQuery(
      { recalc_account_id: account.AccountId },
      { skip: !account?.AccountId },
    );

  const { data: powerData, isFetching: isFetchingPower } =
    useGetPortfolioAnalysisPowerQuery(
      { recalc_account_id: account?.AccountId },
      { skip: !account?.AccountId },
    );
  const { data: waterData, isFetching: isFetchingWater } =
    useGetPortfolioAnalysisWaterQuery(
      { recalc_account_id: account?.AccountId },
      { skip: !account?.AccountId },
    );
  const { data: heatData, isFetching: isFetchingHeat } =
    useGetPortfolioAnalysisHeatQuery(
      { recalc_account_id: account?.AccountId },
      { skip: !account?.AccountId },
    );
  const isFetching =
    isFetchingSubscription ||
    isFetchingPower ||
    isFetchingWater ||
    isFetchingHeat;
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            verticalAlign: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      }
    >
      <PortfolioAnalysisManagementDrawer
        key={account.AccountId}
        account={{
          ...account,
          jsonObjects: [
            { object: subscriptionData, name: 'Subscriptions' },
            { object: powerData, name: 'Power', nameKey: 'address' },
            { object: waterData, name: 'Water', nameKey: 'address' },
            { object: heatData, name: 'Heat', nameKey: 'address' },
          ],
        }}
        open={isOpen}
        onClose={onClose}
        subscription={subscriptionData}
        isFetching={isFetching}
      />
    </Suspense>
  );
};

export default PortfolioAnalysisDrawerContainer;
